"use client";
import React from "react";
import Image from "next/image";

const departments = [
  {
    name: "Computer Science & Engineering",
    image: "/images/Hero.jpg",
  },
  {
    name: "Mechanical Engineering",
    image: "/images/Hero.jpg",
  },
  {
    name: "Civil Engineering",
    image: "/images/Hero.jpg",
  },
  {
    name: "Electrical & Electronics Engineering",
    image: "/images/Hero.jpg",
  },
  {
    name: "Electronics & Communication Engineering",
    image: "/images/Hero.jpg",
  },
  {
    name: "MBA (Management Studies)",
    image: "/images/Hero.jpg",
  },
  {
    name: "Pharmacy",
    image: "/images/Hero.jpg",
  },
  {
    name: "Applied Sciences",
    image: "/images/Hero.jpg",
  },
];

export default function OurDepartments() {
  return (
    <section className="bg-[#f8fafc] min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-12">
          Our Departments
        </h1>

        {/* Grid */}
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {departments.map((dept, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              {/* Image */}
              <div className="relative w-full h-48">
                <Image
                  src={dept.image}
                  alt={dept.name}
                  fill
                  className="object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-teal-700 transition">
                  {dept.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}